import { FhMenuInterface } from '../interfaces/fh-menu-interface';
import { EventEmitter } from '@angular/core';

export class FhMenuModel implements FhMenuInterface {
  tag = '';
  icon? = '';
  title = '';
  link?: string;
  outlet?: string;
  level = 0;
  visible? = false;
  expanded = true;
  featured = false;
  parentTag?: string = '';
  childs?: FhMenuModel[];
  external = false;
  id? = '';
  queryParams: any;
  simulationType: any;
  state?: any;
  dropdownOpen = false;
  object?: any;
  active: boolean = false;
  relativeRoute?: boolean = false;
  translationKey?: string = '';
  parentItem?: FhMenuModel;

  constructor(init?: Partial<FhMenuModel>) {
    Object.assign(this, init);
  }
}
